import React from "react";
import styled from "styled-components";

import Logo from "../logo";

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1024px;
  width: 100%;

  @media (min-width: 1024px) {
  }
`;

const Box = styled.div`
  padding: 20px;
  height: 90px;
  display: flex;
  align-items: flex-start;

  @media (min-width: 768px) {
    height: 140px;
  }

  @media (min-width: 1024px) {
    justify-content: center;
  }
`;

const Nav = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const NavItem = styled.a`
  text-decoration: none;
  font-family: ${(props) => props.theme.typo.fontFamily};
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme.palette.secondary};
  margin-left: 10px;
`;

const Header = () => (
  <Box>
    <Container>
      <Logo />
      <Nav>
        <NavItem href="https://natif.ai/#pricing">Pricing</NavItem>
        <NavItem href="https://natif.ai/#about">About</NavItem>
        <NavItem href="https://natif.ai/#jobs">Jobs</NavItem>
      </Nav>
    </Container>
  </Box>
);

export default Header;
